import './WorkHours.css';
import {useEffect, useState, useSyncExternalStore} from 'react';
import {Link, Routes, Route, useNavigate} from 'react-router-dom';
import FadeIn from '../../utils/fadein';
import Spinner from '../../components/layout/Spinner';
import { getUserWorkHours, saveWorkHour, pauseCompany, getUserCompany, refreshToken } from '../../utils/api';
import { refresh } from '../../services/auth.service';

const WorkHours = () => {
  const [workHours, setWorkHours] = useState([]);
  let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const [hours, setHours] = useState([]);
  const [userWorkHours, setUserWorkHours] = useState([]);
  const [isPaused, setIsPaused] = useState(false);
  const [showSaveBanner, setShowSaveBanner] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  async function loadWorkHours(){
    let res2 = await getUserWorkHours();
    let tmp_data = [];

    if (res2.success){
      setUserWorkHours(res2.data);
      tmp_data = res2.data;
      setLoading(false);
    }

    else if (res.status === 403){
      await refresh();

      let res2 = await getUserWorkHours();
      let tmp_data = [];

      if (res2.success){
        setUserWorkHours(res2.data);
        tmp_data = res2.data;
      }

      setLoading(false);
    }

    let res = days.map((item, index) => {
      let start_time = '';
      let end_time = '';

      if (tmp_data.filter(x => x.day_of_week === index).length > 0){
        start_time = tmp_data.filter(y => y.day_of_week === index)[0].start_time;
        end_time = tmp_data.filter(y => y.day_of_week === index)[0].end_time;
      }

      return {
        day: index,
        name: item,
        start_time: start_time,
        end_time: end_time,
        is_active: tmp_data.filter(item2 => item2.day_of_week===index).length > 0
      }
    });

    setWorkHours(res);
    //loadCompany();
  }

  useEffect(() => {
    async function loadWorkHours(){
      let res2 = await getUserWorkHours();
      let tmp_data = [];

      if (res2.success){
        setUserWorkHours(res2.data);
        tmp_data = res2.data;
        setLoading(false);
      }

      else if (res.status === 403){
        await refresh();

        let res2 = await getUserWorkHours();
        let tmp_data = [];

        if (res2.success){
          setUserWorkHours(res2.data);
          tmp_data = res2.data;
        }

        setLoading(false);
      }

      let res = days.map((item, index) => {
        let start_time = '';
        let end_time = '';

        if (tmp_data.filter(x => x.day_of_week === index).length > 0){
          start_time = tmp_data.filter(y => y.day_of_week === index)[0].start_time;
          end_time = tmp_data.filter(y => y.day_of_week === index)[0].end_time;
        }

        return {
          day: index,
          name: item,
          start_time: start_time,
          end_time: end_time,
          is_active: tmp_data.filter(item2 => item2.day_of_week===index).length > 0
        }
      });

      setWorkHours(res);
      //loadCompany();
    }

    loadWorkHours();
  }, []);

  useEffect(() => {
    async function loadHours(){
      // load hours from 12:00am - 11:30pm
      // for every hour, load the hour at 0 and the 30 minute interval
      let tmp = [];
      for (let i = 0; i < 24; i++){
        let h = 0;
        let isAm = true;

        if (i > 12)
        {
          h = i - 12;
          isAm = false;
        }
        else if (i === 0)
          h = 12;
        else
          h = i;

        let obj = {text: `${h}:00${isAm ? " am": " pm"}`, value: (i * 100)};
        let obj2 = {text: `${h}:30${isAm ? " am" : "pm"}`, value: (i * 100) + 30};

        tmp.push(obj);
        tmp.push(obj2);
      }

      setHours(tmp);
    }

    loadHours();
  }, []);

  async function handleDaySelect(index){
    if (userWorkHours.filter(item => item.day_of_week===index).length === 0){
      // select workhour
      let data = {day_of_week: index, is_active: true, start_time: 900, end_time: 1700};
      let res = await saveWorkHour(data);

      if (res.success){
        let tmp = {
          day_of_week: index,
          is_active: true,
          start_time: 900,
          end_time: 1700
        };

        setUserWorkHours([...userWorkHours, tmp]);
        loadWorkHours();
      }

      else if (res.status === 403){
        await refresh();

        let res = await saveWorkHour(data);

        if (res.success){
          let tmp = {
            day_of_week: index,
            is_active: true,
            start_time: 900,
            end_time: 1700
          };

          setUserWorkHours([...userWorkHours, tmp]);
          loadWorkHours();
        }
      }
    }

    else{
      // already selected
      // deselect
      let data = {day_of_week: index, is_active: false};
      let res = await saveWorkHour(data);

      let tmp = userWorkHours.filter(item => item.day_of_week !== index);
      setUserWorkHours(tmp);
    }

    loadSaveBanner();
  }

  async function handleSaveHourStart(e, day_of_week){
    let data = {day_of_week, start_time: e.target.value};
    let res = await saveWorkHour(data);

    // save workhours starttime for day
    let tmp = workHours.map(x => {
      if (parseInt(x.day) === parseInt(day_of_week)){
        x.start_time = parseInt(e.target.value);
      }

      return x;
    });

    setWorkHours(tmp);
    loadSaveBanner();
  }

  function loadSaveBanner(){
    setShowSaveBanner(true);
    const timer = setTimeout(() => {
      setShowSaveBanner(false);
    }, 3000);
    return () => clearTimeout(timer);
  }

  async function handleSaveHourEnd(e, day_of_week){
    let data = {day_of_week, end_time: e.target.value};
    let res = await saveWorkHour(data);

    let tmp = workHours.map(x => {
      if (parseInt(x.day) === parseInt(day_of_week)){
        x.end_time = parseInt(e.target.value);
      }

      return x;
    });

    setWorkHours(tmp);
    loadSaveBanner();
  }

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-8">
        <div className="mb-6">
                <Link 
                  className='inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 ease-in-out'
                  to="/account/home"
                >
                  <span className="mr-2">←</span>
                  Back
                </Link>
              </div> 
      </div>

      <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Weekly Work Hours</h1>
        
        <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
          <p className="text-sm text-blue-700">
            Set your weekly work hours. Demos will only be booked within these times.
          </p>
        </div>

        {loading ? (
          <Spinner />
        ) : (
          <div className="space-y-4">
            {workHours.map((item, index) => (
              <div key={item.day} className="flex flex-col md:flex-row items-start md:items-center p-2 bg-gray-50 rounded-lg hover:bg-gray-100">
                <div className="flex items-center mb-4 md:mb-0 md:w-1/3">
                  <label className="inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      className="form-checkbox h-5 w-5 text-purple-600 rounded border-gray-300 focus:ring-purple-500"
                      checked={userWorkHours.filter(x => x.day_of_week === index).length > 0}
                      onChange={() => handleDaySelect(index)}
                    />
                    <span className="ml-2 text-gray-700 font-medium">{item.name}</span>
                  </label>
                </div>

                {userWorkHours.filter(item => item.day_of_week === index).length > 0 && (
                  <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4 w-full md:w-2/3">
                    <div className="flex-1">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Start Time</label>
                      <select 
                        className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-purple-500 focus:border-purple-500 sm:text-sm rounded-md"
                        onChange={(e) => handleSaveHourStart(e, index)}
                      >
                        {hours.map(item2 => (
                          <option 
                            key={item2.value} 
                            value={item2.value} 
                            selected={item2.value === item.start_time}
                          >
                            {item2.text}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="flex-1">
                      <label className="block text-sm font-medium text-gray-700 mb-1">End Time</label>
                      <select 
                        className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-purple-500 focus:border-purple-500 sm:text-sm rounded-md"
                        onChange={(e) => handleSaveHourEnd(e, index)}
                      >
                        {hours.map(item2 => (
                          <option 
                            key={item2.value} 
                            value={item2.value} 
                            selected={item2.value === item.end_time}
                          >
                            {item2.text}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {showSaveBanner && (
        <FadeIn delay={150} duration={300}>
          <div className="fixed bottom-4 right-4 bg-green-50 border-l-4 border-green-400 p-4 rounded-lg shadow-lg">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-green-700">
                  Settings saved successfully!
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      )}
    </div>
  );
}

export default WorkHours;